<template>
  <BaseModal :modal-id="modalId" :css-classes="cssClasses" title="Zvolte filtr">
    <div class="mb-1 mt-2 mb-md-3 mt-md-4">
      <div v-for="(section, index) in sections" :key="index">
        <p class="brands-popular__heading">{{ section.title }}</p>
        <div class="row">
          <FilterCheckbox
            v-for="option in section.options"
            :key="option.id"
            :field-id="`section-${index}-${option.id}`"
            :option="option"
            :selected-options="selectedPerSection[index]"
            @toggled="toggled(index, $event)"
          />
        </div>
        <hr v-if="index < sections.length - 1" class="brands-popular__divider" />
      </div>
    </div>

    <template v-slot:ok-button>
      <button @click="saveAndClose" type="button" class="btn btn-lg btn-gray flex-fill flex-sm-grow-0">Uložit</button>
    </template>
  </BaseModal>
</template>

<script>
import BaseModal from './BaseModal.vue'
import FilterCheckbox from '../filter/FilterCheckbox.vue'

export default {
  name: 'MultiSectionSelectionModal',

  components: { BaseModal, FilterCheckbox },

  emits: ['selected', 'section-changed'],

  props: {
    sections: {
      type: Array,
      default: () => [],
    },
    modalId: {
      type: String,
      default: () => `modal-id-${Math.random().toString(36).slice(7)}`,
    },
    cssClasses: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      selectedPerSection: this.sections.map(s => [...(s.savedOptions || [])]),
    }
  },

  computed: {
    openModalId() {
      return this.$store.state.ModalStore.openedModalId
    },
  },

  watch: {
    openModalId(value) {
      if (value === this.modalId) {
        this.selectedPerSection = this.sections.map(s => [...(s.savedOptions || [])])
      }
    },
  },

  methods: {
    toggled(sectionIndex, option) {
      const selected = this.selectedPerSection[sectionIndex]
      const index = selected.findIndex(o => o.id === option.id)
      if (index >= 0) {
        selected.splice(index, 1)
      } else {
        selected.push(option)
      }
      this.$emit('section-changed', this.selectedPerSection)
    },

    saveAndClose() {
      this.$emit('selected', this.selectedPerSection)
      this.$store.dispatch('ModalStore/closeModal')
    },
  },
}
</script>
